import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { combineReducers } from 'redux';
import * as actionTypes from "../actions/actionTypes";

// eslint-disable-next-line default-param-last
export var popup = function popup() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === actionTypes.SET_POPUP_STATE) {
    var newState = _objectSpread({}, state);
    var _action$payload = action.payload,
      id = _action$payload.id,
      opened = _action$payload.opened,
      data = _action$payload.data;
    if (data) {
      newState[id] = _objectSpread(_objectSpread({}, state[id]), {}, {
        opened: opened,
        data: data
      });
      return newState;
    }
    newState[id] = _objectSpread(_objectSpread({}, state[id]), {}, {
      opened: opened
    });
    return newState;
  }
  return state;
};

// eslint-disable-next-line default-param-last
export var regionData = function regionData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === actionTypes.SET_REGION_DATA) {
    return action.payload;
  }
  return state;
};
var core = combineReducers({
  popup: popup,
  regionData: regionData
});
export default core;